import { LOGO_URL } from "@/lib/api";

export default function Logo({ size = 32, withWordmark = true, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Lemonade"
        width={size}
        height={size}
        className="rounded-[20%] shadow-sm ring-1 ring-black/5"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <span className="font-display text-2xl tracking-tight" style={{ letterSpacing: "-0.03em" }}>
          Lemonade
        </span>
      )}
    </div>
  );
}
